/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs */

const en_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Mag7X Strat holds equal-weight positions in eight companies: the Magnificent 7 (Apple, Microsoft, Nvidia, Alphabet, Amazon, Meta, Tesla) plus SpaceX.`)
};

const de_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Mag7X Strat hält gleich gewichtete Positionen in acht Unternehmen: die Magnificent 7 (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta und Tesla) plus SpaceX.`)
};

const pt_br2_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O Mag7X Strat mantém posições com pesos iguais em oito empresas: as Magnificent 7 (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta e Tesla) mais a SpaceX.`)
};

const tr_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7X Strat, sekiz şirkette eşit ağırlıklı pozisyonlar tutar: Magnificent 7 (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta ve Tesla) ve ek olarak SpaceX.`)
};

const zh_cn2_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7X Strat 等权重持有八家公司：“七巨头”（苹果、微软、英伟达、Alphabet、亚马逊、Meta 和特斯拉）加上 SpaceX。`)
};

const zh_hk2_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7X Strat 以等權重持有八家公司：「Magnificent 7」（Apple、Microsoft、NVIDIA、Alphabet、Amazon、Meta 及 Tesla）加上 SpaceX。`)
};

const ko_kr2_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7X Strat은 여덟 개 기업, 즉 Magnificent 7(Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta, Tesla)과 SpaceX를 동일 비중으로 보유합니다.`)
};

const ru_ru2_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag7X Strat держит равновзвешенные позиции в восьми компаниях: «Великолепная семёрка» (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta и Tesla) плюс SpaceX.`)
};

const es_419_campaigns_mag7_spacex_fine_print_holdings = /** @type {(inputs: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El Mag7X Strat mantiene posiciones de igual ponderación en ocho empresas: las Magnificent 7 (Apple, Microsoft, NVIDIA, Alphabet, Amazon, Meta y Tesla) más SpaceX.`)
};

/**
* | output |
* | --- |
* | "The Mag7X Strat holds equal-weight positions in eight companies: the Magnificent 7 (Apple, Microsoft, Nvidia, Alphabet, Amazon, Meta, Tesla) plus SpaceX." |
*
* @param {Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const campaigns_mag7_spacex_fine_print_holdings = /** @type {((inputs?: Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Campaigns_Mag7_Spacex_Fine_Print_HoldingsInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_campaigns_mag7_spacex_fine_print_holdings(inputs)
	if (locale === "de") return de_campaigns_mag7_spacex_fine_print_holdings(inputs)
	if (locale === "pt-BR") return pt_br2_campaigns_mag7_spacex_fine_print_holdings(inputs)
	if (locale === "tr") return tr_campaigns_mag7_spacex_fine_print_holdings(inputs)
	if (locale === "zh-CN") return zh_cn2_campaigns_mag7_spacex_fine_print_holdings(inputs)
	if (locale === "zh-HK") return zh_hk2_campaigns_mag7_spacex_fine_print_holdings(inputs)
	if (locale === "ko-KR") return ko_kr2_campaigns_mag7_spacex_fine_print_holdings(inputs)
	if (locale === "ru-RU") return ru_ru2_campaigns_mag7_spacex_fine_print_holdings(inputs)
	return es_419_campaigns_mag7_spacex_fine_print_holdings(inputs)
});